// components/assignmentTexts/assType_8.js
import React from "react";
import { FaHourglassHalf, FaClock, FaCheckCircle } from "react-icons/fa";


export const makeAssType_8 = ({ book, user, openRedirectedLink }) => ({
    4: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_audible_asin || "Not found",
            icon1:  <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title1: "Access the book and listen",
            description1: "You can download the book. Once you have listened to it, click the 'Next Step' button.",
            icon2:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Complete listening & review",
            description2: "We are waiting for you to finish the previous step. Then you can post your review.",
            icon3:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Approve review",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your review.",
            full_title1: "Access the Audiobook and Listen for Free with Audible Promo Code",
            full_subtitle1: "This is an Audible Promo Code Assignment. This type of Assignment cannot be canceled.",
            full_description1: (
                <p>Follow the link below to find the specified audiobook on Audible.
                    Copy the promo code and redeem it on the page: <button
                        type="button"
                        className="btn btn-link p-0 align-baseline"
                        onClick={() => openRedirectedLink?.(`${user?.user?.audible_country}/promo/redemption`)}
                    >
                        Audible Redemption Page
                    </button>.

                    Once redeemed, listen to the audiobook using the Audible app.
                    Enjoy your listening experience!</p>
            ),
            full_title2: "Listen to the Audiobook and Post your review on Audible",
            full_subtitle2: "This Assignment cannot be canceled.",
            full_description2: (
                <p>Enjoy the audiobook and share your honest thoughts in a detailed review.
                    Click the button below to post it on Amazon. Make sure your review is original, accurate, and respectful.
                    AI-generated, plagiarized, generic, inaccurate, defamatory, or discriminatory reviews are not allowed.
                    If it doesn’t appear right away, don’t worry – Audible may take some time to approve it.</p>
            ),
            full_title3: "Turn in this assignment",
            full_subtitle3: "We will track your review on Audible.",
            full_description3: ( <p>Click the button below to submit your assignment. Do this immediately after posting your review on Audible.
                    This is a required step in the review process.
                    Our staff will monitor the appearance of your review on Audible for 14 days..</p>
            ),
            full_title4: " full_title4:step1:",
            full_subtitle4: " full_subtitle4:step1.",
            full_description4: ( <p>full_description4:step1</p>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_audible_asin || "Not found",
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Access the book and listen",
            description1: "You have completed this step! Now you can do more. Please finish listening and post your review.",
            icon2: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title2: "Complete listening & review",
            description2: "You are now on the second step of the assignment. Please finish listening and post your review.",
            icon3:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Approve review",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your review.",
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",
            full_title2: "Listen to the Audiobook and Post your review on Audible",
            full_subtitle2: "This Assignment cannot be canceled.",
            full_description2: (
                <p>Enjoy the audiobook and share your honest thoughts in a detailed review.
                    Click the button below to post it on Amazon. Make sure your review is original, accurate, and respectful.
                    AI-generated, plagiarized, generic, inaccurate, defamatory, or discriminatory reviews are not allowed.
                    If it doesn’t appear right away, don’t worry – Audible may take some time to approve it.</p>
            ),
            full_title3: "Turn in this assignment",
            full_subtitle3: "We will track your review on Audible.",
            full_description3: ( <p>Click the button below to submit your assignment. Do this immediately after posting your review on Audible.
                    This is a required step in the review process.
                    Our staff will monitor the appearance of your review on Audible for 14 days.</p>
            ),
            full_title4: " full_title4:step1:",
            full_subtitle4: " full_subtitle4:step1.",
            full_description4: ( <p>full_description4:step1</p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_audible_asin || "Not found",
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Access the book and listen",
            description1: "You have completed this step! Now you can do more. Please finish listening and post your review.",
            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Complete listening & review",
            description2: "You posted review. Well Done!",
            icon3:  <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title3: "Turn in this assignment",
            description3: "You are now on the third step of the assignment. Check and turn in this assignment.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Approve review",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your review.",
            full_title1: "Access the book and read it for Free Well Done!",
            full_subtitle1: "",
            full_description1: "",
            full_title2: "",
            full_subtitle2: "",
            full_description2: "",
            full_title3: "Turn in this assignment",
            full_subtitle3: "We will track your review on Audible.",
            full_description3: ( <p>Click the button below to submit your assignment. Do this immediately after posting your review on Audible.
                    This is a required step in the review process.
                    Our staff will monitor the appearance of your review on Audible for 14 days.</p>
            ),
            full_title4: " full_title4:step1:",
            full_subtitle4: " full_subtitle4:step1.",
            full_description4: ( <p>full_description4:step1</p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_audible_asin || "Not found",
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Access the book and listen",
            description1: "You have completed this step! Now you can do more. Please finish listening and post your review.",
            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Complete listening & review",
            description2: "You posted review. Well Done!",
            icon3:  <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "You reported about review successfully posted! Now we must wait a little bit for approval.",
            icon4:  <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title4: "Awaiting for approval:",
            description4: "We receive your report and will check it. Provide the direct link to your reviewer page on Audible.",
            full_title1: "Access the book and read it for Free Well Done!",
            full_subtitle1: "",
            full_description1: "",
            full_title2: "Read the book and post your review on Amazon",
            full_subtitle2: "Note: Once you complete this step, you will not be able to cancel this assignment.",
            full_description2: ( <p>Enjoy the book and share your honest thoughts in a detailed review.
                    Click the button below to post it on Amazon. Make sure your review is original, accurate, and respectful.
                    AI-generated, plagiarized, generic, inaccurate, defamatory, or discriminatory reviews are not allowed.
                    If it doesn’t appear right away, don’t worry - Audible may take some time to approve it.</p>
            ),
            full_title3: "",
            full_subtitle3: "",
            full_description3: "",
            full_title4: "What author expects from your Review?",
            full_subtitle4: "This is an Audible Promo Code Assignment, and its author expects that...",
            full_description4: ( <p>Your review will contain at least a few sentences, clearly convey your thoughts,
                    and not be plagiarized or AI-generated. Please ensure that you have posted a well-written review that accurately
                    reflects your opinion of the book.
                    <b> Additionally,</b> we expect that the published review matches the characteristics you previously declared:</p>
            ),
            verified_purchase: "Not needed",
            photo: "Not needed",
            review_name: user?.user?.audible_name || "Not found",
            review_site: user?.user?.audible_country || "Audible",
        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_audible_asin || "Not found",
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Access the book and listen",
            description1: "You have completed this step! Now you can do more. Please finish listening and post your review.",
            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Complete listening & review",
            description2: "You posted review. Well Done!",
            icon3:  <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "You reported about review successfully posted! Now we must wait a little bit for approval.",
            icon4:  <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Assignment confirmed!",
            description4: "Congratulations, this assignment is fully confirmed!",
            full_subtitle1: "",
            full_description1: "",
            full_title2: "",
            full_subtitle2: "",
            full_description2: "",
            full_title3: "",
            full_subtitle3: "",
            full_description3: "",
            full_title4: "",
            full_title5: "Congratulations, this assignment is fully confirmed!",
            full_subtitle5: "You can find the verification results in the table below.",
            full_description5: ( <p>Please note that if the expected parameters do not match the verification results, we will have to adjust the balance.</p>),

            review_name: user?.user?.audible_name || "Not found",
            review_site: user?.user?.audible_country || "Audible",
        },
    }
});
